export default "__VITE_ASSET__CWV2COt7__"